import React from 'react';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-white py-8 md:py-12 px-4 overflow-hidden" data-id="element-64">
      <div className="max-w-3xl mx-auto text-center" data-id="element-65">
        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-3 leading-tight font-['Oswald'] uppercase" data-id="element-66">
          ¿Tu hijo se aburre{' '}
          <span className="text-[#c0392b]" data-id="element-67">al estudiar?</span>
        </h1>

        <p className="text-base md:text-lg text-gray-600 mb-5 max-w-xl mx-auto" data-id="element-68">
          Descubre la forma de hacer que aprender sea divertido, visual y algo
          que realmente quiera hacer… <strong data-id="element-69">sin obligarlo.</strong>
        </p>

        <a href="#compra" className="mb-5 relative group cursor-pointer block" data-id="element-70">
          <img src="https://cdn.magicpatterns.com/uploads/saYUTDYpN8fr6GUJP11rvk/mockup_guia_educativa_para_ninos.png" alt="Guía Educativa para Niños - Cuerpo Humano" className="relative mx-auto w-full max-w-xs transform transition hover:scale-105 duration-300" data-id="element-71" />
        </a>

        <div className="flex flex-col items-center gap-2 mb-5 max-w-sm mx-auto" data-id="element-72">
          {['Despierta su curiosidad natural', 'Menos pantallas, más aprendizaje real', 'Ideal para niños de 6 a 10 años'].map((item, idx) => <div key={idx} className="flex items-center gap-2 text-left w-full" data-id="element-73">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-74" />
              <span className="text-sm font-semibold text-gray-800" data-id="element-75">
                {item}
              </span>
            </div>)}
        </div>

        <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-base md:text-lg font-black py-4 px-6 md:px-10 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all w-full max-w-md uppercase flex items-center justify-center gap-2 animate-pulse no-underline mx-auto" data-id="element-76">
          👉 Quiero que mi hijo disfrute aprender
        </a>
      </div>
    </section>;
}